export default "__VITE_ASSET__5b0724d0__"